"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = List;

var _Collection = _interopRequireDefault(require("./Collection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/List.html
 *
 * @extends {javascript.util.Collection}
 * @constructor
 * @private
 */
function List() {}

;
List.prototype = Object.create(_Collection.default.prototype);
List.prototype.constructor = List;
/**
 * Returns the element at the specified position in this list.
 * @param {number} index
 * @return {Object}
 */

List.prototype.get = function () {};
/**
 * Replaces the element at the specified position in this list with the
 * specified element (optional operation).
 * @param {number} index
 * @param {Object} e
 * @return {Object}
 */


List.prototype.set = function () {};
/**
 * Returns true if this collection contains no elements.
 * @return {boolean}
 */


List.prototype.isEmpty = function () {};